var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"transaction bgcbdr"},[_c('h3',{staticClass:"mb3"},[_vm._v(_vm._s(_vm.$t("transactions_title")))]),_c('div',[_c('vue-table-dynamic',{staticStyle:{"text-align":"center !important"},attrs:{"params":_vm.params}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }